import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "../App.css";
import logoLight from "../obr/FCA_App_black2.png";
import logoDark from "../obr/FCA_App_gold2.png";

export default function PrveSpustenie() {
  const { dokoncitPrveSpustenie } = useAuth();
  const nav = useNavigate();

  const [heslo1, setHeslo1] = useState("");
  const [heslo2, setHeslo2] = useState("");
  const [err, setErr] = useState("");

  const nacitajTemu = () => {
    const ulozena = localStorage.getItem("tema");
    return ulozena === "dark" ? "dark" : "light";
  };

  const [tema] = useState(nacitajTemu);
  const aktualneLogo = tema === "light" ? logoLight : logoDark;

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", tema);
  }, [tema]);

  const submitDokoncenie = async (e) => {
    e.preventDefault();
    setErr("");

    try {
      await dokoncitPrveSpustenie(heslo1, heslo2);
      nav("/app", { replace: true });
    } catch (e2) {
      const msg = e2.message || "Nepodarilo sa nastaviť nové heslo.";
      setErr(msg);

      if (msg.includes("Onboarding relácia vypršala")) {
        nav("/login", { replace: true });
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-logo-wrap">
          <img src={aktualneLogo} alt="FinCloud" className="login-logo" />
        </div>

        <div className="App login-app">
          <div className="card-section login-card">
            <h2>Prvé spustenie</h2>

            <form onSubmit={submitDokoncenie} className="form-group">
              <div className="form" style={{ gridColumn: "1 / -1" }}>
                <label className="form_label">Nové heslo</label>
                <input
                  className="form_input"
                  type="password"
                  value={heslo1}
                  onChange={(e) => setHeslo1(e.target.value)}
                />
              </div>

              <div className="form" style={{ gridColumn: "1 / -1" }}>
                <label className="form_label">Potvrdenie nového hesla</label>
                <input
                  className="form_input"
                  type="password"
                  value={heslo2}
                  onChange={(e) => setHeslo2(e.target.value)}
                />
              </div>

              {err && (
                <div className="form" style={{ gridColumn: "1 / -1" }}>
                  <div className="form_hint error">{err}</div>
                </div>
              )}

              <div className="form-actions form-actions--full">
                <button
                  type="submit"
                  className="form_input action-btn"
                >
                  Uložiť nové heslo
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}